import {authRoute, registerRedirectRoute} from '../scenes/auth';
import {onboardingRoute} from '../scenes/onboarding';
import {homepageRoutes} from '../scenes/homepage';
import {recipesRoutes} from '../scenes/recipes';
import {recipeRoutes} from '../scenes/recipe';
import {articlesRoutes} from '../scenes/articles';
import {articleRoutes} from '../scenes/article';
import {giftsRoutes} from '../scenes/gifts';
import {profileRoutes} from '../scenes/profile';
import {formationsRoutes} from '../scenes/formations';
import {formationRoutes} from '../scenes/formation';
import {postRoutes} from '../scenes/post';
import {productsRoutes} from '../scenes/products';

export const authenticated = [
  ...recipeRoutes,
  ...profileRoutes,
  ...giftsRoutes,
  ...articlesRoutes,
  ...articleRoutes,
  ...recipesRoutes,
  ...formationsRoutes,
  ...formationRoutes,
  ...postRoutes,
  ...productsRoutes,
  ...homepageRoutes,
];

export const anonymous = [registerRedirectRoute, authRoute, onboardingRoute];
